@if (cstQuestionnaireService.currentSection) {
<div class="question-create-panel">
    <div class="title no-border full-width">
        <mat-form-field
            appearance="outline"
            class="full-width input-form-field m-t-10"
        >
            <textarea
                matInput
                type="text"
                [placeholder]="placeholder"
                [(ngModel)]="cstQuestionnaireService.currentSection.section"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                maxlength="1000"
                cdkAutosizeMaxRows="5"
                (ngModelChange)="onChangeSection($event)"
                required
            ></textarea>
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            class="full-width input-form-field"
        >
            <textarea
                matInput
                class="section_description fs-14 text-left"
                type="text"
                [placeholder]="descriptionPlaceholder"
                [(ngModel)]="cstQuestionnaireService.currentSection.description"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                maxlength="1000"
                (ngModelChange)="onChangeDescription($event)"
                required
            ></textarea>
        </mat-form-field>
    </div>
</div>
}
